<template>
  <div class="mainMenu" :class="{'isCollapse':isCollapse}">
    <div class="wrap">
      <div class="logo">
        <div class="normal" v-show="!isCollapse" />
        <div class="mini" v-show="isCollapse" />
      </div>
      <el-scrollbar>
        <el-menu ref="sideMenu" :default-active="defaultActive" :collapse="isCollapse" :collapse-transition="false">
          <menuItem v-for="route in menuList" :key="route.name" :item="route" />
        </el-menu>
        <div class="menuBottomLine" />
      </el-scrollbar>
      <!--      <div class="narrow" @click="collapseChange">-->
      <!--        <i :class="isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'" />-->
      <!--      </div>-->
    </div>
  </div>
</template>
<script type="es6">
import menuItem from './menuItem';
export default {
  model: {
    prop: 'isCollapse',
    event: 'change'
  },
  props: {
    menuList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultActive: '',
      prevActive: '' // 新增：记录最后一次成功路由
    };
  },
  components: {
    menuItem
  },
  computed: {
  },
  methods: {
    collapseChange () {
      this.$store.commit('routerMenu/setMenuCollapseFlag', !this.isCollapse);
      this.$emit('change', !this.isCollapse);
    },
    initDefIndex (val) {
      if (val.meta && val.meta.active) {
        this.defaultActive = val.meta.active;
        return;
      }
      this.defaultActive = val.path;
      this.prevActive = this.defaultActive;
    },
    restoreActive (path) {
      const target = path || this.prevActive;
      this.defaultActive = target;
      this.prevActive = target;
      this.$nextTick(() => {
        if (this.$refs.sideMenu) {
          this.$refs.sideMenu.activeIndex = target;        // 强制覆盖内部状态
          // 如果有展开子菜单需求，可调用内部方法（存在才调用）
          this.$refs.sideMenu.openActiveItemMenus && this.$refs.sideMenu.openActiveItemMenus();
        }
      });
    }
  },
  watch: {
    '$route': function (val) {
      this.initDefIndex(val);
    }
  },
  mounted () {
    this.initDefIndex(this.$route);
    // 监听恢复事件
    this.$root.$on('restore-menu-active', (path) => {
      this.restoreActive(path);
    });
  },
  beforeDestroy () {
    this.$root.$off('restore-menu-active');
  },
  destroyed () {
  }
};
</script>
<style lang="scss" scoped>
.mainMenu{
  position: fixed;
  width: 230px;
  top: 0;
  left: 0;
  bottom: 0;
  box-shadow: none;
  background: #353F50;
  z-index: 1;
  transition: width 0.3s ease-in-out;
  &.isCollapse{
    width: 64px;
  }
  >.wrap{
    width: 100%;
    height: 100%;
    position: relative;
    >.logo{
      width: 100%;
      height: 60px;
      >div{
        width: 100%;
        height: 100%;
        background-size: auto 40%;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: #313D4A;
        border-bottom: 1px solid #29313d;
        border-right: 1px solid #29313d;
      }
      >.normal{
        background-image: url("../assets/images/rj-logo.png");
      }
      >.mini{
        background-image: url("../assets/images/logo-mini.png");
      }
    }
    ::v-deep>.el-scrollbar{
      position: absolute;
      top: 60px;
      left: 0;
      width: 100%;
      bottom: 50px;
      .el-scrollbar__wrap{
        overflow-x: hidden;
      }
      .el-menu {
        background: #353F50;
        border: none;
        .el-submenu {
          .el-submenu__title {
            height: 60px;
            line-height: 60px;
            color: #7E8A9D;
            border-top: 1px solid #3f4a58;
            border-bottom: 1px solid #262f3b;
            &:hover {
              background: #62707F;
              color: #FFFFFF !important;
              >i {
                color: #FFFFFF !important;
              }
            }

            > .iconfont {
              font-size: 16px;
              color: #7E8A9D !important;
              margin-right: 8px;
            }

            > .el-submenu__icon-arrow {
              color: #7E8A9D;
            }
          }

          > .el-menu {
            background: #353F50;
          }
        }

        .el-menu-item {
          height: 60px;
          line-height: 60px;
          color: #7E8A9D !important;
          border-top: 1px solid #3f4a58;
          border-bottom: 1px solid #262f3b;
          > .iconfont {
            font-size: 16px;
            color: #7E8A9D !important;
            margin-right: 8px;
          }

          &:focus {
            background: transparent;
          }
          &>span{
            position: relative;
            >.tipsNum{
              font-style: normal;
              width: 18px;
              height: 18px;
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: content-box;
              background: #F56C6C;
              color: #FFFFFF;
              position: absolute;
              top: -11px;
              right: -20px;
              border-radius: 10px;
              font-size: 22px;
              &.widening{
                padding: 0 4px;
                right: -26px;
              }
              >span{
                display: inline-block;
                transform: scale(.5);
              }
            }
          }

          &:hover {
            background: #62707F !important;
            >span{
              color: #FFFFFF;
              position: relative;
            }
            >i {
              color: #FFFFFF!important;
            }
          }

          &.is-active {
            background: none;
            color: #FFFFFF!important;
            >i{
              color: #FFFFFF!important;
            }
            &:before {
              display: none;
            }
          }
        }
      }
      .menuBottomLine{
        height: 1px;
        background: #3f4a58;
      }
    }
    >.narrow{
      width: 12px;
      height: 120px;
      position: absolute;
      right: -12px;
      top: 50%;
      background: #D8DCE3;
      border-radius: 0 24px 24px 0;
      cursor: pointer;
      text-align: center;
      line-height: 120px;
    }
  }
}
</style>
